import React from 'react';
import { MainContainer, ElementContainer } from './ChartSummary.styles';
import { Link, withRouter } from 'react-router-dom'

const ChartSummary = ({
    logo, position, organisation, 
    title, project, summary, chartImage, link, chartTypes, libraries, 
    dataSources, date, logoSize, component
}) => {
    return (
        <> 
            <MainContainer
                position={position}
            >
                <ElementContainer
                    logoSizer={logoSize}
                    area="logo"
                >
                    <img    src={logo} 
                            alt={`${organisation}-logo`}
                            className="logo"   
                    />
                </ElementContainer>
                <ElementContainer
                    area="title"
                    justify="flex-start"
                    align="flex-start"
                    direction="column"
                    lineHeight={2.75}
                >
                    <h1>
                        {title}
                    </h1>
                    <h4>
                        {date}&nbsp; - &nbsp;{project}
                    </h4>
                </ElementContainer>
                <ElementContainer
                    area="summary"
                    justify="flex-start"
                    align="flex-start"
                >
                    <p>
                        {summary}
                    </p>
                </ElementContainer>
                <ElementContainer
                    area="image"
                >
                    <div className="image-container">
                        <div className="image-overlay"/>
                        {
                            component === 'none'
                                ?   <a
                                        href={`https://boringbarchart.com${link}`}
                                        // target="_blank"
                                        rel="noopener noreferrer"
                                        className="link-button"
                                    >
                                        See more <span>▸</span>
                                    </a>
                                :   <Link   to={link}
                                        className="link-button"
                                    >
                                        See more <span>▸</span>
                                    </Link>
                        }
                        <img    src={chartImage} 
                                alt={`${title}-screenshot`}
                                className="image"
                        />
                    </div>
                </ElementContainer>
                <ElementContainer
                    area="charts"
                    align="flex-start"
                    direction="column"
                >   
                    <h4>Chart types</h4>
                    <ElementContainer
                        noPadding
                    >
                        {
                            chartTypes.map((chartType, i) => (
                                <p key={i}>{chartType}{ i === chartTypes.length -1 ? '' : ','}&nbsp;</p>
                            ))
                        }
                    </ElementContainer>
                </ElementContainer>

                <ElementContainer
                    area="libs"
                    align="flex-start"
                    direction="column"
                >   
                    <h4>Libraries</h4>
                    <ElementContainer
                        noPadding
                    >
                        {
                            libraries.map((lib, i) => (
                                <p key={i}>{lib}{ i === libraries.length -1 ? '' : ','}&nbsp;</p>
                            ))
                        }
                    </ElementContainer>
                </ElementContainer>

                <ElementContainer
                    area="sources"
                    align="flex-start"
                    direction="column"
                >   
                    <h4>Data sources</h4>
                    <ElementContainer
                        noPadding
                    >
                        {
                            dataSources.map((source, i) => (
                                <p key={i}>{source}{ i === dataSources.length -1 ? '' : ','}&nbsp;</p>
                            ))
                        }
                    </ElementContainer>
                </ElementContainer>


            </MainContainer>
        </>
     );
}
 
export default withRouter(ChartSummary);